import { queryOptions, useQuery } from '@tanstack/react-query';

import { ListSlackWorkspacesResponse } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const SLACK_WORKSPACES_QUERY_KEY = 'slack-workspaces';

export const getSlackWorkspacesQueryKey = (orgId?: string) =>
  [
    SLACK_WORKSPACES_QUERY_KEY,
    ...(orgId !== undefined ? [orgId] : []),
  ] as const;

const getSlackWorkspacesQueryOptions = (orgId: string | undefined) =>
  queryOptions<ListSlackWorkspacesResponse>({
    queryKey: getSlackWorkspacesQueryKey(orgId),
    queryFn: async (): Promise<ListSlackWorkspacesResponse> => {
      const { data } = await apiClient.notifications.listSlackWorkspaces({});
      return data;
    },
  });

export const useGetSlackWorkspaces = () => {
  const { currentOrganization } = useOrganizations();
  const { data, error, isLoading } = useQuery(
    getSlackWorkspacesQueryOptions(currentOrganization?.id)
  );

  return { data, error, isLoading };
};
